export default __webpack_public_path__ + "static/media/calendar_icon.fb3ea851.svg";